import MessageSellSideButton from './MessageSellSideButton.component';

export default MessageSellSideButton;
